<template>
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="16" fill="currentColor" />
        <path
            d="M7 12L14.89 17.26C15.2187 17.4793 15.6049 17.5963 16 17.5963C16.3951 17.5963 16.7813 17.4793 17.11 17.26L25 12M9 23H23C23.5304 23 24.0391 22.7893 24.4142 22.4142C24.7893 22.0391 25 21.5304 25 21V11C25 10.4696 24.7893 9.96086 24.4142 9.58579C24.0391 9.21071 23.5304 9 23 9H9C8.46957 9 7.96086 9.21071 7.58579 9.58579C7.21071 9.96086 7 10.4696 7 11V21C7 21.5304 7.21071 22.0391 7.58579 22.4142C7.96086 22.7893 8.46957 23 9 23Z"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: "CircleMailIcon",
};
</script>
